export default __webpack_public_path__ + "static/media/Läsårstider-hem-2023-2024.ca78bd3a.pdf";